// extracted by mini-css-extract-plugin
module.exports = {"animate":"HomeListRows_animate__12eYk"};